import * as fromDatatype from '../datatype-library/index';

export interface bl_bi_report_query_run_output_file_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  query_run_hdr_guid: fromDatatype.GuidDataFieldInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  file_storage_path: fromDatatype.VarcharDatatypeInterface;
  file_name: fromDatatype.VarcharDatatypeInterface;
  file_type: fromDatatype.VarcharDatatypeInterface;
  file_extension: fromDatatype.VarcharDatatypeInterface;
  file_description: fromDatatype.TextDatatypeInterface;
  file_storage_depth: fromDatatype.NumericDatatypeInterface;
  storage_service: fromDatatype.VarcharDatatypeInterface;
  file_url: fromDatatype.VarcharDatatypeInterface;
  mime_type: fromDatatype.VarcharDatatypeInterface;
  date_edited: fromDatatype.TimestampTzDatatypeInterface;
  date_accessed: fromDatatype.TimestampTzDatatypeInterface;
  ref_ext_guid: fromDatatype.GuidDataFieldInterface;
  ref_ext_table: fromDatatype.VarcharDatatypeInterface;
  bucket_name: fromDatatype.VarcharDatatypeInterface;
  bucket_key: fromDatatype.VarcharDatatypeInterface;
  content_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  file_guid: fromDatatype.GuidDataFieldInterface;
  export_type: fromDatatype.VarcharDatatypeInterface;
  file_size: fromDatatype.NumericDatatypeInterface;
  export_format: fromDatatype.VarcharDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  error_message: fromDatatype.VarcharDatatypeInterface;
}

export class bl_bi_report_query_run_output_file_hdr_RowClass
  implements bl_bi_report_query_run_output_file_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  query_run_hdr_guid: fromDatatype.GuidDataFieldInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  file_storage_path: fromDatatype.VarcharDatatypeInterface;
  file_name: fromDatatype.VarcharDatatypeInterface;
  file_type: fromDatatype.VarcharDatatypeInterface;
  file_extension: fromDatatype.VarcharDatatypeInterface;
  file_description: fromDatatype.TextDatatypeInterface;
  file_storage_depth: fromDatatype.NumericDatatypeInterface;
  storage_service: fromDatatype.VarcharDatatypeInterface;
  file_url: fromDatatype.VarcharDatatypeInterface;
  mime_type: fromDatatype.VarcharDatatypeInterface;
  date_edited: fromDatatype.TimestampTzDatatypeInterface;
  date_accessed: fromDatatype.TimestampTzDatatypeInterface;
  ref_ext_guid: fromDatatype.GuidDataFieldInterface;
  ref_ext_table: fromDatatype.VarcharDatatypeInterface;
  bucket_name: fromDatatype.VarcharDatatypeInterface;
  bucket_key: fromDatatype.VarcharDatatypeInterface;
  content_type: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  file_guid: fromDatatype.GuidDataFieldInterface;
  export_type: fromDatatype.VarcharDatatypeInterface;
  file_size: fromDatatype.NumericDatatypeInterface;
  export_format: fromDatatype.VarcharDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  error_message: fromDatatype.VarcharDatatypeInterface;
}
